"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/pulse.svg.js",
    _path,
    _path2;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M12.003 14.578a2.769 2.769 0 002.776-2.77c0-.742-.289-1.438-.814-1.962a2.782 2.782 0 00-3.925 0 2.752 2.752 0 00-.813 1.961 2.769 2.769 0 002.776 2.771zm-.7-3.466a.986.986 0 01.7-.288.986.986 0 01.987.983c0 .263-.103.51-.288.695a.991.991 0 01-1.398 0 .975.975 0 01-.288-.695c0-.262.102-.509.288-.695zM15.27 15.719a.891.891 0 001.266 0 5.492 5.492 0 001.623-3.912 5.491 5.491 0 00-1.623-3.912.894.894 0 10-1.264 1.266 3.714 3.714 0 011.099 2.646c0 1-.39 1.94-1.099 2.647a.894.894 0 00-.001 1.264zM7.465 15.72a.892.892 0 001.265-.002.894.894 0 00-.001-1.264 3.716 3.716 0 01-1.099-2.647c0-1 .39-1.94 1.099-2.646a.894.894 0 10-1.264-1.266 5.493 5.493 0 00-1.623 3.912c0 1.478.576 2.868 1.623 3.913z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M19.486 11.807a7.41 7.41 0 01-2.191 5.28.894.894 0 001.263 1.266 9.187 9.187 0 002.717-6.546 9.187 9.187 0 00-2.717-6.545.894.894 0 10-1.263 1.266 7.41 7.41 0 012.191 5.28zM6.073 18.614a.894.894 0 00.632-1.527 7.41 7.41 0 01-2.191-5.28 7.41 7.41 0 012.191-5.28.894.894 0 10-1.263-1.266 9.188 9.188 0 00-2.717 6.546c0 2.473.965 4.798 2.717 6.546a.892.892 0 00.631.261z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;